import React from 'react';

import storage from '../../../../player/js/storage';

import { useScheduleContext } from '../../context/ScheduleContext';
import { useUserContext } from '../../context/UserContext';
import { useLocaleContext } from '../../context/LocaleContext';
import { useEventContext } from '../../context/EventContext';
import { useModalContext } from '../../context/ModalContext';
import { useWidgetContext } from '../../context/WidgetContextProvider';
import { episodeLikeToggle } from '../../utils/api';

import { ScheduleBoardOffline } from './ScheduleBoardOffline';
import { ScheduleBoardOnline } from './ScheduleBoardOnline';
import UserAuthenticationModal from '../User/UserAuthenticationModal';

const Schedule = ({type = 'offline', isActiveFavorites, onEpisodeClick}) => {
    const {schedule, episodes} = useScheduleContext();
    const { user } = useUserContext();
    const $locale = useLocaleContext();
    const { event } = useEventContext();
    const { renderModal } = useModalContext();
    const { isWidget } = useWidgetContext();

    const onRateToggle = async (ratedStorageKey, episodeId, isRated, ratedStorageValue) => {
        await episodeLikeToggle(episodeId, isRated);
        storage.set(ratedStorageKey, ratedStorageValue, storage.DAY * 30);
    }

    const checkAuth = (currentUser) => {
        return new Promise((resolve) => {
            if (!currentUser) {
                renderModal(UserAuthenticationModal, {
                    event,
                    $locale,
                    onClose: (props) => resolve(props?.isAuth),
                }, null, true)
            } else {
                resolve(true);
            }
        });
    };
    
    if (!schedule?.length && (!isActiveFavorites || !episodes?.length)) {
        return (
            <div style={{height: 280}} />
        )
    }

    if (type === 'online') {
        return <ScheduleBoardOnline />;
    }

    return (
        <ScheduleBoardOffline
            isActiveFavorites={isActiveFavorites}
            onEpisodeClick={onEpisodeClick}
            checkAuth={checkAuth}
            onRateEpisode={!isWidget && event.moduleEpisode?.like ? onRateToggle : undefined}
            currentUser={user}
        />
    );
};

export default Schedule;
